export default "__VITE_ASSET__Cp3h0Z9b__"